
import React from 'react';

export const UploadIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 13.5V3.5" stroke="white" strokeLinecap="square" strokeLinejoin="round"/>
        <path d="M3.5 7L8 2.5L12.5 7" stroke="white" strokeLinecap="square"/>
    </svg>
);
